import { render } from "./ItemInformation.vue?vue&type=template&id=609f8694"
import script from "./ItemInformation.vue?vue&type=script&lang=js"
export * from "./ItemInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__